import isNumber from 'lodash/isNumber'

import { pluralize } from 'lmcv/modules/utils'

export const message = {
  error: text =>
    `Algo inesperado aconteceu ao carregar ${text}, tente novamente mais tarde.`
}

export const coupon = {
  expire: days => {
    if (isNumber(days)) {
      return days === 0
        ? 'Expira hoje'
        : `Expira em ${days} ${pluralize('dia', days > 1)}`
    }

    return ''
  }
}
